import { LazyLoad } from 'app/utils';

export const CourseListPage = LazyLoad(
  () => import('./index'),
  (module) => module.CourseListPage,
);
